import { Button, Dialog } from '@dreamtree-org/twreact-ui';

/**
 * A destructive action always asks first (rules 11 + 13). Composition over
 * twreact-ui's Dialog so every confirmation in the app reads the same way.
 */
export default function ConfirmDialog({
  isOpen,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Continue',
  cancelLabel = 'Cancel',
  variant = 'destructive',
  loading = false,
  onConfirm,
  onClose,
  children,
}) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </div>
      }
    >
      {message ? <p className="text-sm text-[var(--app-text)]">{message}</p> : null}
      {children}
    </Dialog>
  );
}
